import { createSelector } from '@ngrx/store';
import { selectState } from '../../config/selectors';

const selectQuizFeatureState = createSelector(selectState, (state) => state.quiz);

export const selectQuiz = (id: string) => createSelector(selectQuizFeatureState, (state) => state[id]?.quiz ?? null);

export const selectQuizLoading = (id: string) => createSelector(selectQuizFeatureState, (state) => state[id]?.loading ?? false);

export const selectQuizLoaded = (id: string) => createSelector(selectQuizFeatureState, (state) => state[id]?.loaded ?? null);
